import React, { useState, useEffect } from 'react'
import './AboutUs.css'
import img1 from '../../assets/about.png'

function AboutUs() {

    const [isResponsive, setIsResponsive] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsResponsive(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className='container'>
            <section className='aboutUs'>
                {isResponsive ? (
                    <>
                        <div className='left-aboutUs'>
                            <div className='about-us'>
                                <h2>شركة الأهرام لتوظيف المصريين بالخارج
                                </h2>
                                <div className='title__line'></div>
                                <p>
                                    هى شركة رائدة و متميزة فى مجال توظيف المصريين بالخارج اكثر من 30 سنة خبرة ، شركة مرخصة من وزارة القوى العاملة و الهجرة بترخيص رقم 128.
                                    متخصصة فى توفير  الايدى العاملة المدربة - المتخصصة  فى جميع المجالات :طبى , هندسي , تعليمى ، مقاولات , صناعى, تجارى , تقنى، محاسبى، إدارى، وغيرها
                                    وتحظى الشركة بسمعة طيبة منذ أكثر من ثلاثين عاما حيث تم تأسيسها عام 1977
                                </p>
                            </div>
                        </div>
                        <div className='right-aboutUs'>
                            <img src={img1} alt='' />
                        </div>
                    </>
                ) : (
                    <>
                        <div className='right-aboutUs'>
                            <img src={img1} alt='' />
                        </div>
                        <div className='left-aboutUs'>
                            <div className='about-us'>
                                <h2>شركة الأهرام لتوظيف المصريين بالخارج
                                </h2>
                                <div className='title__line'></div>
                                <p>
                                    هى شركة رائدة و متميزة فى مجال توظيف المصريين بالخارج اكثر من 30 سنة خبرة ، شركة مرخصة من وزارة القوى العاملة و الهجرة بترخيص رقم 128.
                                    متخصصة فى توفير  الايدى العاملة المدربة - المتخصصة  فى جميع المجالات :طبى , هندسي , تعليمى ، مقاولات , صناعى, تجارى , تقنى، محاسبى، إدارى، وغيرها
                                    وتحظى الشركة بسمعة طيبة منذ أكثر من ثلاثين عاما حيث تم تأسيسها عام 1977
                                </p>
                            </div>
                        </div>
                    </>
                )}
            </section>
            
            {/* Video Section */}
            <section className='video-section'>
                <div className='video-wrapper'>
                    <video 
                        controls 
                        className='about-video'
                    >
                        {/* <source src={require("../../assets/moka2025-08-12 154719.mp4")} type="video/mp4" /> */}
                        متصفحك لا يدعم تشغيل الفيديو
                    </video>
                </div>
                <div className='video-container'>
                    <h2>شاهد فيديو تعريفي عن شركة الأهرام</h2>
                    <div className='title__line'></div>
                    <p className='video-description'>
                        تعرف على المزيد عن خدماتنا وخبرتنا في مجال توظيف المصريين بالخارج من خلال هذا الفيديو التعريفي
                    </p>
                </div>
            </section>
        </div>
    )
}

export default AboutUs